import { combineReducers, Action } from '@reduxjs/toolkit';

import api from 'src/api/rtk/rtk-api';

import { absencesSlice } from './absence/absences.slice';
import { absenceBalancesSlice } from './absenceBalance/absenceBalance.slice';
import { departmentsSlice } from './departments/departments.slice';
import { jobsSlice } from './jobs/jobs.slice';
import { localizationSlice } from './localizations/localizations.slice';
import { punchAssignmentsSlice } from './punchAssignment/punchAssignment.slice';
import { punchesSlice } from './punches/punches.slice';
import { timecardSlice } from './timecard/timecard.slice';
import { userSlice } from './user/user.slice';

const reducers = combineReducers({
  [api.reducerPath]: api.reducer,
  absences: absencesSlice.reducer,
  absenceBalances: absenceBalancesSlice.reducer,
  departments: departmentsSlice.reducer,
  jobs: jobsSlice.reducer,
  localizations: localizationSlice.reducer,
  punchAssignments: punchAssignmentsSlice.reducer,
  punches: punchesSlice.reducer,
  timeCard: timecardSlice.reducer,
  user: userSlice.reducer,
});

const rootReducer = (state: ReturnType<typeof reducers> | undefined, action: Action<string>) => {
  if (action.type === 'user/logout/fulfilled') {
    state = undefined;
  }

  return reducers(state, action);
};

export default rootReducer;
